

// Define MyComponent as a functional component
const MyComponent = () => {
  // Render the component
  return (
    <div>
      {/* Display the title */}
      <h1>Truman Records</h1>

      {/* Display the subtitle */}
      <h2>Take a journey along Truman road</h2>
    </div>
  );
};

// Export MyComponent as default export
export default MyComponent;
